import type { ChatMessage, Conversation, Overview, Project, Session } from './types.js';

export const demoProject: Project = {
  id: '11111111-1111-4111-8111-111111111111',
  name: 'Кухни на заказ',
  slug: 'kitchens',
  role: 'admin',
  channelCount: 3,
  conversationCount: 184,
  messageCount: 1472,
  qualifiedCount: 67,
  estimatedCost: '8.42',
  isOwner: true,
};

export const demoSession: Session = {
  user: {
    id: '22222222-2222-4222-8222-222222222222',
    fanleadUserId: '33333333-3333-4333-8333-333333333333',
    fanleadId: '739184205',
    displayName: 'Павел Хрипушин',
    avatarEmoji: '🚀',
  },
  projects: [demoProject],
  csrfToken: 'demo-only',
  accountMenu: { items: [{ label: 'Проекты SalesAI', href: '/app' }] },
};

export const demoConversations: Conversation[] = [
  {
    id: 'a1',
    publicId: '1739469326',
    title: 'Анна Морозова',
    mode: 'bot',
    botConfigured: true,
    qualification: 'qualified',
    automationOutcome: 'agreement',
    automationOutcomeReason: 'Клиент подтвердил замер на точное время',
    messageCount: 18,
    lastMessageAt: new Date().toISOString(),
    channelId: 'c1',
    channelName: 'VK · Кухни Мечты',
    provider: 'vk',
    lastMessage: 'Да, замер в четверг после 18:00 будет удобно',
    estimatedCost: '0.004218',
    costCalculated: true,
    aiSessionCount: 1,
    latestAiSession: {
      id: 'demo-ai-session-1',
      number: 1,
      status: 'active',
      openedAt: '2026-09-29T09:41:00+03:00',
      estimatedCost: '0.004218',
      costCalculated: true,
    },
    unread: 2,
    labelIds: ['label-hot'],
    followUp: {
      status: 'paused_task',
      step: 1,
      taskTitle: 'Созвониться и подтвердить замер',
      taskDueAt: new Date(Date.now() + 24 * 60 * 60_000).toISOString(),
    },
  },
  {
    id: 'a2',
    publicId: '1754955189',
    title: 'Михаил С.',
    mode: 'manual',
    botConfigured: true,
    qualification: 'unknown',
    automationOutcome: 'manager',
    automationOutcomeReason: 'Клиенту нужен индивидуальный расчёт',
    messageCount: 9,
    lastMessageAt: new Date(Date.now() - 6 * 60_000).toISOString(),
    channelId: 'c2',
    channelName: 'TG · showroom_bot',
    provider: 'telegram',
    lastMessage: 'Можно рассчитать вариант с островом?',
    unread: 1,
    labelIds: [],
  },
  {
    id: 'a3',
    publicId: '1770441052',
    title: 'Елена',
    mode: 'bot',
    botConfigured: true,
    qualification: 'unqualified',
    automationOutcome: 'negative',
    automationOutcomeReason: 'Клиент отказался продолжать диалог',
    messageCount: 6,
    lastMessageAt: new Date(Date.now() - 22 * 60_000).toISOString(),
    channelId: 'c1',
    channelName: 'VK · Кухни Мечты',
    provider: 'vk',
    lastMessage: 'Спасибо, пока просто смотрю варианты',
    labelIds: ['label-later'],
  },
];

export const demoMessages: ChatMessage[] = [
  {
    id: 'm1',
    direction: 'inbound',
    senderName: 'Анна',
    text: 'Здравствуйте! Нужна кухня в новую квартиру, помещение 12 м².',
    status: 'received',
    createdAt: '2026-09-29T09:41:00+03:00',
    attachments: [],
  },
  {
    id: 'm2',
    direction: 'outbound',
    text: 'Анна, здравствуйте! Помогу сориентироваться. Подскажите, пожалуйста, планировка прямая, угловая или П-образная?',
    status: 'sent',
    createdAt: '2026-09-29T09:41:12+03:00',
    attachments: [],
  },
  {
    id: 'm3',
    direction: 'inbound',
    senderName: 'Анна',
    text: 'Угловая. Фасады хочется светлые, бюджет примерно до 450 тысяч.',
    status: 'received',
    createdAt: '2026-09-29T09:43:00+03:00',
    attachments: [],
  },
  {
    id: 'm4',
    direction: 'outbound',
    text: 'Понял: угловая светлая кухня, ориентир до 450 000 ₽. В этот бюджет можно собрать несколько вариантов. Чтобы расчёт был точнее, предложу бесплатный замер — какой день удобнее?',
    status: 'sent',
    createdAt: '2026-09-29T09:43:19+03:00',
    usage: {
      estimatedCost: '0.004218',
      costCalculated: true,
      currency: 'USD',
      inputTokens: '20048',
      cachedInputTokens: '19712',
      cacheWriteInputTokens: '0',
      outputTokens: '934',
      reasoningTokens: '640',
      totalTokens: '20982',
      calls: 2,
      hiddenCalls: 1,
    },
    attachments: [],
  },
  {
    id: 'm5',
    direction: 'inbound',
    senderName: 'Анна',
    text: 'Да, замер в четверг после 18:00 будет удобно',
    status: 'received',
    createdAt: '2026-09-29T09:45:00+03:00',
    attachments: [],
  },
];

export const demoOverview: Overview = {
  summary: {
    conversations: 184,
    messages: 1472,
    qualified: 67,
    input_tokens: '384200',
    output_tokens: '91600',
    estimated_cost: '8.42',
  },
  channels: [
    {
      id: 'c1',
      publicId: '1785926915',
      provider: 'vk',
      name: 'Кухни Мечты',
      status: 'active',
      model: 'gpt-5-mini',
      aiEnabled: true,
      promptId: 'p1',
      promptName: 'Первичная квалификация',
      promptVersionId: 'pv1',
      timeZone: 'Europe/Moscow',
      workDays: [1, 2, 3, 4, 5],
      workdayStart: '09:00',
      workdayEnd: '18:00',
    },
    {
      id: 'c2',
      publicId: '1801412778',
      provider: 'telegram',
      name: 'Showroom bot',
      providerMetadata: { username: 'showroom_bot' },
      status: 'active',
      model: 'gpt-5-mini',
      aiEnabled: true,
      promptId: 'p1',
      promptName: 'Первичная квалификация',
      promptVersionId: 'pv1',
      timeZone: 'Europe/Moscow',
      workDays: [1, 2, 3, 4, 5],
      workdayStart: '09:00',
      workdayEnd: '18:00',
    },
    {
      id: 'c3',
      publicId: '1816898641',
      provider: 'vk',
      name: 'Дизайн интерьера',
      status: 'pending',
      model: 'gpt-5-mini',
      aiEnabled: false,
      timeZone: 'Europe/Moscow',
      workDays: [1, 2, 3, 4, 5],
      workdayStart: '09:00',
      workdayEnd: '18:00',
    },
  ],
  prompts: [
    {
      id: 'p1',
      name: 'Первичная квалификация',
      content:
        'Ты — внимательный менеджер по продажам. Выясни потребность клиента, ответь по существу и предложи следующий конкретный шаг. Не выдумывай цены и условия.',
      versionId: 'pv1',
      version: 4,
      channelIds: ['c1', 'c2'],
      successCriteria: 'Клиент подтвердил заказ, оплатил или оставил данные для выполнения заявки.',
      negativeCriteria: 'Клиент явно отказался, попросил больше не писать или пожаловался на спам.',
      agreementCriteria: 'Клиент подтвердил точную дату и время следующего контакта.',
      handoffCriteria: 'Нужен индивидуальный расчёт, решение конфликта или действие живого менеджера.',
      negativeReplyLimit: 1,
      notifyOnSuccess: true,
      notifyOnHandoff: true,
      followUpEnabled: true,
      followUpDelaysMinutes: [30, 1440],
      followUpPrompt:
        'Продолжи диалог ненавязчиво: напомни о предыдущем сообщении, добавь пользу и предложи простой следующий шаг.',
      followUpSteps: [
        { stepOrder: 1, delayMinutes: 30, useStandardPrompt: true },
        { stepOrder: 2, delayMinutes: 1440, useStandardPrompt: true },
        {
          stepOrder: 3,
          delayMinutes: 4320,
          useStandardPrompt: false,
          prompt: 'Предложи клиенту последний простой следующий шаг и оставь возможность вернуться позже.',
        },
      ],
    },
  ],
  labels: [
    { id: 'label-hot', name: 'Горячий', color: '#ef4444' },
    { id: 'label-later', name: 'Вернуться позже', color: '#8b5cf6' },
  ],
  comments: {
    enabled: false,
    channelIds: ['c2'],
    keywords: [],
    prompt: 'Ответь на комментарий от лица сообщества. Будь полезным, кратким и естественным. Не выдумывай факты.',
  },
  ai: {
    defaultModel: 'gpt-5-mini',
    keyConfigured: true,
    keyHint: 'sk-••••••••demo',
    keyStatus: 'active',
    keyCheckedAt: new Date().toISOString(),
    keyStatusDetail: 'Ключ принят OpenAI',
  },
};
